import { Lock, ScrollText } from "lucide-react";

export function EvidenceBoundary({ privateItems = [], receiptItems = [], compact = false }) {
  return (
    <div
      data-testid="evidence-boundary"
      className={`grid grid-cols-1 gap-0 overflow-hidden rounded-2xl border border-stone-200 bg-white ${compact ? "" : "md:grid-cols-[1fr_auto_1fr]"}`}
    >
      {/* Stays private */}
      <div className="p-5">
        <div className="flex items-center gap-2 text-mill-moss">
          <Lock className="h-4 w-4" />
          <span className="text-xs font-semibold uppercase tracking-[0.14em]">Stays private — ordinary system</span>
        </div>
        <ul className="mt-3 space-y-2">
          {privateItems.map((it) => (
            <li key={it} className="flex items-start gap-2 text-sm text-mill-ink">
              <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-mill-moss" />
              {it}
            </li>
          ))}
        </ul>
      </div>

      {/* Boundary */}
      <div className="relative hidden items-center justify-center px-2 md:flex">
        <div className="boundary-beam h-full w-0.5" />
      </div>
      <div className="boundary-beam h-0.5 w-full md:hidden" />

      {/* Could be a receipt */}
      <div className="bg-[#FFFDF5] p-5">
        <div className="flex items-center gap-2 text-[#B45309]">
          <ScrollText className="h-4 w-4" />
          <span className="text-xs font-semibold uppercase tracking-[0.14em]">Could be a KATLAS receipt</span>
        </div>
        <ul className="mt-3 space-y-2">
          {receiptItems.map((it) => (
            <li key={it} className="flex items-start gap-2 text-sm text-mill-ink">
              <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-katlas-receipt" />
              {it}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
